'use client'
import Image from 'next/image'

import { clsx } from 'clsx'

import { FC, useState } from 'react'

import { Feedback, Maybe } from '@/app/graphql/generated'
import { IconArrow } from '@/app/shared/icons'
import { ImageLetsGo } from '@/app/shared/images'
import { IClassName } from '@/app/shared/interfaces/common.interface'
import { CollapseComponent } from '@/app/shared/ui/collapse'

// interface
interface ICardReview extends IClassName {
  data: Maybe<Feedback>
}

// component
const CardReviewComponent: FC<Readonly<ICardReview>> = ({ className, data }) => {
  const [show, setShow] = useState(false)
  const [showBtn, setShowBtn] = useState(false)

  return (
    <div
      className={clsx(
        'grid rounded-[20px] border-2 border-content1-500 bg-content1-200 p-[30px]',
        className,
      )}
    >
      <div className={'mb-[21px] grid items-start mobile:flex mobile:justify-between'}>
        <div className={'order-2 flex mobile:order-1'}>
          <div
            className={`relative mr-[20px] h-[85px] w-[79px] flex-shrink-0`}
            style={{
              maskImage: "url('comment.png')",
            }}
          >
            <Image src={data?.image ?? ImageLetsGo} alt={'review'} fill sizes={'79px'} />
          </div>
          <span className={'text-[22px] font-semibold'}>{data?.name}</span>
        </div>
        <span
          className={
            'order-1 ml-auto flex h-[26px] flex-shrink-0 items-center rounded-large bg-content1-500 px-2.5 text-[10px] font-semibold text-content1-200 mobile:order-2 mobile:text-[12px]'
          }
        >
          {data?.language_level}
        </span>
      </div>
      <CollapseComponent open={show} setIsMoreText={setShowBtn} defaultHeight={80}>
        <p className={'overflow-hidden text-[14px] leading-5'}>{data?.text}</p>
      </CollapseComponent>
      {showBtn && (
        <button
          onClick={() => setShow(!show)}
          type={'button'}
          className={'ml-auto mt-2.5 flex items-center font-semibold uppercase text-success'}
        >
          Читати більше{' '}
          <IconArrow
            className={clsx('ml-[5px] h-[12px] w-[11px] transition-transform', {
              'rotate-180': show,
            })}
          />
        </button>
      )}
    </div>
  )
}

export default CardReviewComponent
